import { OBJECTIVEMULTISEARCH_SUCCESS, OBJECTIVEMULTISEARCH_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const objectiveMultiSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case OBJECTIVEMULTISEARCH_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case OBJECTIVEMULTISEARCH_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default objectiveMultiSearchReducer;



